import DealServiceWizard from "./components/wizard";
import style from "./styles.module.scss";

const DealService = () => {
  return (
    <section className={style.dealServiceWizard}>
      <div className={style.dealServiceWizard__container}>
        <DealServiceWizard />
      </div>
    </section>
  );
};

export default DealService;
